"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconBAPlusFilled = function IconBAPlusFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "BAPlus"), _react.default.createElement("path", {
    d: "M37 29.62C36.9113 29.4111 36.7745 29.2261 36.6007 29.0801C36.4269 28.9341 36.2211 28.8313 36 28.78L33.91 28.33L17.69 24.81C17.359 24.7446 17.0655 24.555 16.87 24.28L13.15 19.28C13.0368 19.1423 12.8827 19.0443 12.71 19L9.49 18.4C8.56 18.24 7.63 18.08 6.69 17.96C6.60345 17.9485 6.51544 17.9558 6.43193 17.9813C6.34843 18.0068 6.27136 18.0499 6.20595 18.1077C6.14054 18.1655 6.0883 18.2367 6.05277 18.3165C6.01724 18.3962 5.99925 18.4827 6 18.57V40H19C19 41.7239 19.6848 43.3772 20.9038 44.5962C22.1228 45.8152 23.7761 46.5 25.5 46.5C27.2239 46.5 28.8772 45.8152 30.0962 44.5962C31.3152 43.3772 32 41.7239 32 40H36.51C36.7566 39.7967 36.9317 39.5199 37.01 39.21C37.5152 37.2369 37.8893 35.2325 38.13 33.21C37.9197 31.9672 37.5394 30.7592 37 29.62ZM25.5 43C24.6522 43.0087 23.8301 42.7093 23.1864 42.1576C22.5426 41.6058 22.1211 40.8391 22 40C21.9848 39.8337 21.9848 39.6663 22 39.5C22 38.5717 22.3687 37.6815 23.0251 37.0251C23.6815 36.3687 24.5717 36 25.5 36C26.4283 36 27.3185 36.3687 27.9749 37.0251C28.6313 37.6815 29 38.5717 29 39.5C29.0152 39.6663 29.0152 39.8337 29 40C28.8789 40.8391 28.4574 41.6058 27.8136 42.1576C27.1699 42.7093 26.3478 43.0087 25.5 43Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M38.7 15.28L29.6 25.34L27.18 24.82L28.9 20.22C28.9114 20.1895 28.9152 20.1568 28.911 20.1245C28.9069 20.0922 28.8949 20.0615 28.8762 20.0349C28.8575 20.0083 28.8326 19.9867 28.8036 19.9719C28.7747 19.9571 28.7425 19.9496 28.71 19.95H20.42C20.3827 19.9478 20.3466 19.9358 20.3155 19.915C20.2844 19.8943 20.2594 19.8656 20.2431 19.832C20.2268 19.7983 20.2198 19.7609 20.2228 19.7237C20.2257 19.6864 20.2386 19.6506 20.26 19.62L32.26 4.87C32.2904 4.83377 32.3327 4.8095 32.3793 4.80148C32.4259 4.79346 32.4738 4.80222 32.5146 4.8262C32.5553 4.85018 32.5863 4.88782 32.6019 4.93246C32.6176 4.97709 32.6169 5.02582 32.6 5.07L29.1 14.68C29.0886 14.7105 29.0848 14.7432 29.089 14.7755C29.0931 14.8078 29.1051 14.8385 29.1238 14.8651C29.1425 14.8917 29.1674 14.9133 29.1964 14.9281C29.2253 14.9429 29.2575 14.9504 29.29 14.95H38.55C38.5881 14.9504 38.6252 14.9616 38.6571 14.9824C38.689 15.0031 38.7143 15.0326 38.7301 15.0672C38.7458 15.1019 38.7514 15.1403 38.746 15.178C38.7407 15.2157 38.7247 15.2511 38.7 15.28Z",
    fill: color
  }));
};

IconBAPlusFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconBAPlusFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconBAPlusFilled;
exports.default = _default;